"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAmbientValueResolver = void 0;
const AmbientValueResolver_1 = require("./AmbientValueResolver");
const invocation_1 = require("../invocation");
class DefaultAmbientValueResolver extends AmbientValueResolver_1.AmbientValueResolver {
    constructor() {
        super(...arguments);
        this.cache = new Map();
        this.activator = new invocation_1.DefaultClassActivator();
    }
    resolve(ambientValueClass) {
        let ambientValue = this.cache.get(ambientValueClass);
        if (!ambientValue) {
            ambientValue = this.activator.activate(ambientValueClass);
            this.cache.set(ambientValueClass, ambientValue);
        }
        return ambientValue;
    }
}
exports.DefaultAmbientValueResolver = DefaultAmbientValueResolver;
//# sourceMappingURL=DefaultAmbientValueResolver.js.map